import { Typography } from "@material-ui/core"
import { AddCircle } from "@material-ui/icons"
import { useContext } from "react"
import DarkButton from "~/components/Common/DarkButton"
import ListTitle from "~/components/Common/ListTitle"
import AppContext from "~/contexts/App"
import LabContext from "~/contexts/Lab"
import LabsContext from "~/contexts/Labs"

import Box from "~/components/Common/Box"
import PermissionsWrapper from "~/components/Common/PermissionsWrapper"

import InstanceCard from "../InstanceCard"
import useStyles from "./styles"

const InstanceList = () => {
  const classes = useStyles()
  const { openDialog } = useContext(AppContext)
  const { instanceTypes } = useContext(LabsContext)
  const { lab } = useContext(LabContext)

  const openCreateDialog = () => {
    openDialog("createInstanceDialog", { instanceTypes, lab })
  }

  return (
    <Box maxWidth={750} marginTop="24px">
      <Box
        display="flex"
        justifyContent="space-between"
        height="40px"
        marginBottom="24px"
      >
        <Typography color="primary" className={classes.instanceHeader}>
          Instances
        </Typography>
        {!lab.locked && lab.instances?.length > 0 && (
          <PermissionsWrapper permissionGroup="admin">
            <DarkButton
              onClick={openCreateDialog}
              startIcon={<AddCircle fontSize="small" />}
            >
              Add Instance
            </DarkButton>
          </PermissionsWrapper>
        )}
      </Box>
      <Box>
        <ListTitle
          list={[
            { name: "", size: 0 },
            { name: "Title", size: "90px" },
            { name: "", size: 0 },
            { name: "Server Type", size: "130px" },
            { name: "", size: 0 },
            { name: "Server Username", size: "130px" },
            { name: "", size: 80 },
          ]}
        />
      </Box>
      <Box marginBottom="32px">
        {lab?.instances?.map((instance) => {
          return <InstanceCard key={instance.id} instance={instance} />
        })}
      </Box>
      {!lab.locked && lab.instances?.length === 0 && (
        <DarkButton
          onClick={openCreateDialog}
          size="large"
          fullWidth
          startIcon={<AddCircle color="inherit" />}
        >
          Add Instance
        </DarkButton>
      )}
    </Box>
  )
}

export default InstanceList
